module.exports = __webpack_public_path__ + "img/1.fe7ac422.png";